import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { YellowCheck } from "../../../images";
import XCloseIcon from "../../../images/svg/xCloseIcon";
import { setFormData, postRequest, logStudentInquiry } from "../../../redux/action";
import { FirstLastName } from "../../../styles/common";
import InputWrapper from "../../inputWrapper";
import styles from "./fast-track.module.css";

const FastTrackForm = ({ onClose }) => {
  const modalRef = useRef();
  const { formData } = useSelector((state) => state);
  const dispatch = useDispatch();

  // Example start date options in the requested format
  const startDateOptions = [
    "Select",
    "July, 6th 2025",
    "August, 15th 2025",
    "September, 10th 2025"
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const { control, register, handleSubmit, reset, formState: { errors } } = useForm({
    mode: "all",
    defaultValues: { phone_number: "+1", start_date: "Select" },
  });

 const onSubmit = async (formData) => {
  const enrollResponse = await postRequest("/api/form-fast-tracks", {
    firstname: formData.firstname,
    lastname: formData.lastname,
    email: formData.email,
    phoneNumber: formData.phone_number,
    // Do NOT send start_date to backend API
  });
  
  // Log student inquiry
  await logStudentInquiry({
    firstName: formData.firstname,
    lastName: formData.lastname,
    email: formData.email,
    phoneNumber: formData.phone_number,
    course: "Fast Track",
    inquiryCategory: "Fast Track Registration"
  });

  if (enrollResponse[0] === true) {
    toast.success(enrollResponse[1].message);
    reset();
    // Pabbly webhook integration
    try {
      const pabblyData = new URLSearchParams({
        First_name: formData.firstname,
        Last_name: formData.lastname,
        Email: formData.email,
        Phone_number: formData.phone_number,
        Start_date: formData.start_date // Send only to Pabbly
      }).toString();
      const webhookUrl = process.env.REACT_APP_PABBLY_WEBHOOK_FAST_TRACK_URL;
      const webhookResponse = await fetch(webhookUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: pabblyData,
      });
      if (!webhookResponse.ok) {
        throw new Error('Webhook submission failed');
      }
      const responseText = await webhookResponse.text();
      console.log('Response from Pabbly:', responseText);
    } catch (error) {
      console.error('Error submitting to Pabbly webhook:', error);
    }
    window.open("https://chat.whatsapp.com/FeZPTsjRIDTG5ayWyt264Y", "_blank");
  } else {
    if (enrollResponse[1]?.details?.errors?.length > 0) {
      toast.error(enrollResponse[1].message);
      for (const error of enrollResponse[1].details.errors) {
        toast.error(error.message);
      }
    } else {
      toast.error("An error occurred. Please try again.", errors);
    }
  }
};


  return (
    <section className={styles["modal-shadow"]}>
      <div className={styles["inner"]} ref={modalRef}>
        <span className={styles["top_btn"]}>
          <XCloseIcon onClick={onClose} fill="white" />
        </span>
        <div className={styles["modal_body"]}>
          <div className={styles["modal_body_left"]}>
            <div className={styles["top_span"]}>
              No previous work experience needed!
            </div>

            <div className={styles["modal_header"]}>
              <span className={styles["sub_header"]}>Business Analysis Fast-Track Course</span>
            </div>
            <div className={styles["modal_desc"]}>
              Fill out this form to register for the upcoming Business Analysis fast-track course.
               You will receive a confirmation email after registration. Subsequently,
               a link will be sent to you to access live session. 
            </div>
            <div className={styles["modal_list"]}>
              <img src={YellowCheck} alt="yellow check" loading="lazy" />
              This course is FREE
            </div>
            <div className={styles["modal_list"]}>
              <img src={YellowCheck} alt="yellow check" loading="lazy" />
              Addresses the fundamentals of business analysis
            </div>
            <div className={styles["modal_list"]}>
              <img src={YellowCheck} alt="yellow check" loading="lazy" />
              Suitable for anyone who wants to gain clarity
            </div>
          </div>

          <div className={styles["modal_body_right"]}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <FirstLastName>
                <InputWrapper
                  title="First Name"
                  placeholder="Philips"
                  fieldName="firstname"
                  requiredMessage="Enter a valid firstname"
                  register={register}
                  errors={errors}
                />

                <InputWrapper
                  title="Last Name"
                  placeholder="Dankano"
                  fieldName="lastname"
                  requiredMessage="Enter a valid lastname"
                  register={register}
                  errors={errors}
                />
              </FirstLastName>

              <InputWrapper
                title="Email"
                type="email"
                placeholder="Example@example.com"
                fieldName="email"
                requiredMessage="Email is required"
                patternValue={/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/}
                patternMessage="Invalid email address"
                compoundValidation={true}
                register={register}
                errors={errors}
              />

              <InputWrapper
                inputTag="Phone Input"
                title="Phone Number"
                fieldName="phone_number"
                requiredMessage="Phone number is required"
                compoundValidation={true}
                control={control}
                register={register}
                errors={errors}
              />

              {/* Start Date Select */}
              {/* <InputWrapper
                inputTag="Select"
                title="Select start date"
                fieldName="start_date"
                options={startDateOptions}
                requiredMessage="Start date is required"
                register={register}
                errors={errors}
              /> */}

              <InputWrapper
                inputTag="Check Box"
                register={register}
                errors={errors}
              />
              <button type="submit" className={styles["submit_btn"]}>
                Register Now
              </button>
            </form>
          </div>
        </div>
      </div>
      <div className={styles.overlay} onClick={onClose} />
    </section>
  )
}

export default FastTrackForm